import { Pipe } from '@angular/core';
import * as moment from 'moment';
var DayOfWeekPipe = (function () {
    function DayOfWeekPipe() {
        this.dayOfWeek = [
            'Domingo',
            'Segunda',
            'Terça',
            'Quarta',
            'Quinta',
            'Sexta',
            'Sábado',
        ];
    }
    DayOfWeekPipe.prototype.transform = function (value, inputFormat) {
        if (inputFormat === void 0) { inputFormat = "YYYY-MM-DD"; }
        var index = (value instanceof Date)
            ? value.getDay() - 1
            : moment(value, inputFormat).day();
        return this.dayOfWeek[index];
    };
    DayOfWeekPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'dayOfWeek',
                },] },
    ];
    /** @nocollapse */
    DayOfWeekPipe.ctorParameters = function () { return []; };
    return DayOfWeekPipe;
}());
export { DayOfWeekPipe };
//# sourceMappingURL=day-of-week.js.map


//////////////////
// WEBPACK FOOTER
// ../ionic-commons/dist/pipes/day-of-week.js
// module id = 389
// module chunks = 0